import {
  GET_COMPONENTS_REQUEST,
  GET_COMPONENTS_SUCCESS,
  GET_COMPONENTS_FAILURE,
  EDIT_COMPONENTS_REQUEST,
  EDIT_COMPONENTS_SUCCESS,
  EDIT_COMPONENTS_FAILURE,
  CREATE_COMPONENTS_REQUEST,
  CREATE_COMPONENTS_SUCCESS,
  CREATE_COMPONENTS_FAILURE,
  DELETE_COMPONENTS_REQUEST,
  DELETE_COMPONENTS_SUCCESS,
  DELETE_COMPONENTS_FAILURE,
} from "./componentsClientsTypes";

import axios from "axios";
import Config from "../../../config/index";
let userManagementUrl = Config.userManagementUrl;

const getComponentsRequest = () => {
  return { 
    type: GET_COMPONENTS_REQUEST,
  };
};

const getComponentsSuccess = (payload) => {
  return {
    type: GET_COMPONENTS_SUCCESS,
    payload: payload,
  };
};

const getComponentsFaliure = (error) => {
  return {
    type: GET_COMPONENTS_FAILURE,
    payload: error,
  };
};

const getComponents = (jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getComponentsRequest());
    let url = `${userManagementUrl}/components/get_all`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getComponentsSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getComponentsFaliure(err.message));
      });
  };
};
const updateUserComponentsRequest = () => {
  return {
    type: EDIT_COMPONENTS_REQUEST,
  };
};

const updateUserComponentsSuccess = (payload) => {
  return {
    type: EDIT_COMPONENTS_SUCCESS,
    payload: payload,
  };
};

const updateUserComponentsFaliure = (error) => {
  return {
    type: EDIT_COMPONENTS_FAILURE,
    payload: error,
  };
};

const updateUserComponents = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(updateUserComponentsRequest());
    let url = `${userManagementUrl}/components/update`;
    return axios
      .put(url, payload, headers)
      .then((response) => {
        dispatch(updateUserComponentsSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(updateUserComponentsFaliure(err.response));
        return { status: false, data: err.response };
      });
  };
};


const createComponentsRequest = () => {
  return {
    type: CREATE_COMPONENTS_REQUEST,
  };
};

const createComponentsSuccess = (payload) => {
  return {
    type: CREATE_COMPONENTS_SUCCESS,
    payload: payload,
  };
};

const createComponentsFaliure = (error) => {
  return {
    type: CREATE_COMPONENTS_FAILURE,
    payload: error,
  };
};

const createComponents = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(createComponentsRequest());
    let url = `${userManagementUrl}/components/create`;
    return axios
      .post(url, payload, headers)
      .then((response) => {
        dispatch(createComponentsSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(createComponentsFaliure(err.response));
        return { status: false, data: err.response };
      });
  };
};



const deleteComponentsRequest = () => {
  return {
    type: DELETE_COMPONENTS_REQUEST,
  };
};

const deleteComponentsSuccess = (payload) => {
  return {
    type: DELETE_COMPONENTS_SUCCESS,
    payload: payload,
  };
};

const deleteComponentsFaliure = (error) => {
  return {
    type: DELETE_COMPONENTS_FAILURE,
    payload: error,
  };
};

const deleteComponents = (componentId, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(deleteComponentsRequest());
    // let url = `${userManagementUrl}/user/delete?componentId=${componentId}`;
    let url = `${userManagementUrl}/components/delete?componentId=${componentId}`;
    return axios
      .delete(url, headers)
      .then((response) => {
        dispatch(deleteComponentsSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(deleteComponentsFaliure(err.response));
        return { status: false, data: err.response };
      });
  };
};

export { getComponents ,createComponents,updateUserComponents,deleteComponents};
